import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

export const knowledgeRoutes: RouteObject[] = [
  { path: '/knowledge', lazy: page(() => import('./pages/KnowledgeSearchPage.js')) },
  { path: '/knowledge/notes', lazy: page(() => import('./pages/MyNotesPage.js')) },
  { path: '/knowledge/people/:userId', lazy: page(() => import('./pages/PersonFootprintPage.js')) },
  { path: '/knowledge/articles', lazy: page(() => import('./pages/ArticleListPage.js')) },
  { path: '/knowledge/articles/:id', lazy: page(() => import('./pages/ArticlePage.js')) },
  { path: '/knowledge/qa', lazy: page(() => import('./pages/QaListPage.js')) },
  { path: '/knowledge/proposals', lazy: page(() => import('./pages/ProposalsPage.js')) },
  { path: '/knowledge/experts', lazy: page(() => import('./pages/ExpertsPage.js')) },
  { path: '/knowledge/handover', lazy: page(() => import('./pages/HandoverPage.js')) },
  { path: '/knowledge/handover/:userId', lazy: page(() => import('./pages/HandoverPage.js')) },
  { path: '/knowledge/admin/sources', lazy: page(() => import('./pages/IngestStatusPage.js')) },
  { path: '/knowledge/admin/folders', lazy: page(() => import('./pages/FolderRulesPage.js')) },
];
